import { TOKEN_PATH, API_BASE } from './constants';
import { TError, TRefreshData } from './types';

export const checkResponse = <T>(res: Response): Promise<T> =>
    res.ok ? res.json() : res.json().then((err) => Promise.reject(err));

export function request<T>(url: string, options: RequestInit): Promise<T> {
    // принимает два аргумента: урл и объект опций, как и `fetch`
    return fetch(url, options).then((res) => checkResponse<T>(res));
}

export const refreshToken = () =>
    request<TRefreshData>(`${API_BASE}${TOKEN_PATH}`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify({
            token: localStorage.getItem('refreshToken'),
        }),
    });

export const fetchWithRefresh = async <T>(
    url: string,
    options: RequestInit
): Promise<T> => {
    try {
        const res = await fetch(url, options);
        return await checkResponse<T>(res);
    } catch (err) {
        if ((err as TError).message === 'jwt expired') {
            // || err.message === 'jwt malformed') {
            const refreshData: TRefreshData = await refreshToken(); // обновляем токен
            if (!refreshData.success) {
                return Promise.reject(refreshData);
            }
            localStorage.setItem('refreshToken', refreshData.refreshToken);
            localStorage.setItem(
                'accessToken',
                refreshData.accessToken.replace('Bearer ', '')
            );
            const res = await fetch(url, {
                ...options,
                headers: {
                    ...options.headers,
                    authorization: `Bearer ${refreshData.accessToken}`,
                },
            });
            // повторяем запрос
            return checkResponse<T>(res);
        }
        return Promise.reject<T>(err);
    }
};
